import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { 
  ScheduledMessages,
  ComposeMessage,
  CreateScheduledMessage,
} from '../../screens/menu/scheduledMessages';

export type ScheduledMessagesStackParamList = {
  ScheduledMessagesList: undefined;
  ComposeMessage: { contact: any };
  CreateScheduledMessage: { selectedContacts?: any[] };
};

const Stack = createNativeStackNavigator<ScheduledMessagesStackParamList>();

const ScheduledMessagesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="ScheduledMessagesList" 
        component={ScheduledMessages} 
      />
      <Stack.Screen 
        name="ComposeMessage" 
        component={ComposeMessage} 
      />
      <Stack.Screen 
        name="CreateScheduledMessage" 
        component={CreateScheduledMessage} 
      />
    </Stack.Navigator>
  );
};

export default ScheduledMessagesStackNavigator; 